import { createSvgIcon } from '@mui/material';

export const HomeIcon = createSvgIcon(
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20">
    <path
      fill="currentColor"
      d="M17.5 16.667a.833.833 0 0 1-.833.833H3.333a.833.833 0 0 1-.833-.833V7.908a.833.833 0 0 1 .322-.658l6.666-5.185a.833.833 0 0 1 1.024 0l6.666 5.185a.832.832 0 0 1 .322.658v8.759Zm-8.333-5.834v5h1.666v-5H9.167Z"
    />
  </svg>,
  'HomeIcon',
);
